import Rest from '@/services/Rest';

export default class MemberService extends Rest {
  static resource = 'member';
}
